import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { AppointmentConfirmation, ConfirmAppointment } from '../types/en-us'

export const useConfirmAppointmentStore = create<ConfirmAppointment>()(
  persist(
    set => ({
      appointmentConfirmation: {} as AppointmentConfirmation,
      setAppointmentConfirmation: (
        ApptConfirmation: AppointmentConfirmation,
      ) => {
        set({ appointmentConfirmation: ApptConfirmation })
      },
      resetAppointmentConfirmation: () =>
        set({ appointmentConfirmation: {} as AppointmentConfirmation }),
    }),
    {
      name: '@ConexaPaciente:patient-confirm-appointment',
      getStorage: () => sessionStorage,
    },
  ),
)
